(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  function sendRecommendedProductForm(btn) {
    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: {
          button: btn,
        },
      })
    );
  }

  const handleIntersection = (entries, observer) => {
  if (!entries[0].isIntersecting) return;

  observer.unobserve(productRecommendationsSection);

  const fetchAndRenderRecommendations = (url) => {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          const recommendationForms = document.querySelectorAll('.cart_recommendation_product__form');

          if (recommendationForms.length > 0) {
            recommendationForms.forEach((recommended_product) => {
              recommended_product.querySelector('.btn').addEventListener('click', () => {
                const btn = event.target;
                sendRecommendedProductForm(btn);
              });
            });
          } else {
            // No recommended products, try 'related' intent
            const relatedUrl = url.replace('intent=complementary', 'intent=related');
            if (relatedUrl !== url) {
              fetchAndRenderRecommendations(relatedUrl);
            }
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const url = productRecommendationsSection.dataset.url;
  fetchAndRenderRecommendations(url);
};

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
